import React from "react";

import RenderOrientation from "../../types/enums/RenderOrientation";
import InputFormField from "./InputFormField";
import RenderOrientations from "../../types/enums/RenderOrientation";

interface InputFormSubformProps {
    label?: string;

    display?: RenderOrientation;
    fieldDisplay?: RenderOrientation;

    children?:
        | React.ReactElement<InputFormField>[]
        | React.ReactElement<InputFormField>;
}

class InputFormSubform extends React.Component<InputFormSubformProps> {
    render(): React.ReactNode {
        let classNames = "subform";

        switch (this.props.display) {
            case RenderOrientations.Vertical:
                classNames += " main-vertical";
                break;
            default:
                classNames += " main-horizontal";
                break;
        }

        switch (this.props.fieldDisplay) {
            case RenderOrientations.Horizontal:
                classNames += " field-horizontal";
                break;
            default:
                classNames += " field-vertical";
                break;
        }

        return (
            <div className={classNames}>
                {this.props.label && (
                    <div className="subform-label">{this.props.label}</div>
                )}
                {this.props.children}
            </div>
        );
    }
}

export default InputFormSubform;
